import React from 'react';
import styled from 'styled-components/macro';
import { createGlobalStyle } from 'styled-components';
import { Modal } from 'src/client/components/modals/Modal/Modal';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { Site } from 'src/client/redux/modules/site';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';

const StyledModal = styled(Modal)`
  .guest-modal-body {
    background-color: #000 !important;
    margin: 0 !important;
    padding: 4px !important;
  }
`;

const FlexBox = styled.div`
  display: flex;
  background-color: #000;
  border-color: #000;
`;

const FlexBoxPhoto = styled.div`
  @media (max-width: 769px) {
    img {
      max-width: 320px;
    }
  }

  @media (max-width: 639px) {
    display: none;
  }
`;

const FlexBoxItem = styled.div`
  flex: 1;
`;

const WelcomeBackBox = styled.div`
  margin: 0 auto;
  text-align: center;
  max-width: 400px;
`;

const SiteLogo = styled.img`
  margin: 12px 0 0;
  max-width: 240px;
`;

const FreeBonusMessage = styled.h4`
  font-weight: 300;
  font-size: 28px;
  margin: 24px auto 12px;
  color: #fff;
  text-align: center;

  @media (max-width: 769px) {
    margin: 6px auto;
  }
`;

const Text = styled.p`
  margin: 12px auto;
  color: #b1b0b1;
`;

const OrText = styled.p`
  margin: 12px auto;
  color: #fff;
  font-size: 24px;

  @media (max-width: 769px) {
    margin: 4px auto;
  }
`;

const StyledButton = styled.a`
  display: block;
  font-size: 16px;
  margin: 0 auto 24px;
  padding-top: 10px;
  height: 80px;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  width: 320px;
  text-align: center;
  cursor: pointer;
  color: #000;
  background: #ceab57;
  border-radius: 5px;

  :hover {
    color: #000;
    text-decoration: none;
  }

  @media (max-width: 769px) {
    margin-bottom: 0;
    height: 70px;
    font-size: 14px;
  }
`;

const BonusContentButton = styled(StyledButton)`
  color: #fff;
  border: 1px solid #fff;
  height: 60px;
  padding-top: 0;
  line-height: 60px;
  font-size: 1.4rem;
  margin: 0 auto;
  text-align: center;
  border-radius: 0;
  background: none;

  :hover {
    color: #fff;
    text-decoration: none;
  }

  @media (max-width: 769px) {
    height: 52px;
    line-height: 52px;
  }
`;

const TryText = styled.p`
  font-weight: 600;
  font-size: 22px;
  margin: 0;
  @media (max-width: 769px) {
    font-size: 18px;
  }
`;

const GlobalStyle = createGlobalStyle`
  .modal-dialog {
    width: 95%;
    border: 0;
  }
  @media (max-width: 640px) {
    .alt-close {
      top:-10px!important;
      right:-10px!important;
    }
  }
`;

const PromoBannerWrapper = styled.div`
  text-align: center;
`;

export type PromoBannerProps = {
  promoSite: Site;
  promoGalleryUUID: string;
  onClose: () => void;
};

export const PromoBanner = (props: PromoBannerProps) => {
  const { promoSite, onClose } = props;
  const parentSite = useSelector((state) => state.site);
  const { cdnUrl } = useSelector((state) => state.app);
  const siteLogoUrl = `${cdnUrl}/logos/${parentSite.networkUUID}/${promoSite.abbreviation}.svg`;
  const [joinUrl] = useJoinUrl({
    campaign: `cross-promo-${parentSite.abbreviation}`,
    overrideSite: promoSite?.abbreviation,
    extraParams: {
      channel: `gallery-${props.promoGalleryUUID}`,
    },
  });

  return (
    <PromoBannerWrapper>
      <GlobalStyle />
      <StyledModal
        altCloseButton
        onHide={onClose}
        dialogClassName={`guest-modal-dialog`}
        modalBodyClassName={`guest-modal-body`}
        show
      >
        <FlexBox>
          <FlexBoxPhoto>
            <img src={`${cdnUrl}/img/guest-gateway.jpg`} alt="" />
          </FlexBoxPhoto>
          <FlexBoxItem>
            <WelcomeBackBox>
              <FreeBonusMessage>Enjoy your FREE BONUS content courtesy of</FreeBonusMessage>
              <SiteLogo alt={promoSite.name} src={siteLogoUrl} />
              <Text>May contain explicit sexual material</Text>
              <BonusContentButton onClick={onClose}>Proceed to BONUS content</BonusContentButton>
              <OrText>or</OrText>
              <StyledButton onClick={onClose} href={joinUrl}>
                <TryText>Try {promoSite.name} for FREE</TryText>
                Enjoy 1000's of films and galleries
              </StyledButton>
            </WelcomeBackBox>
          </FlexBoxItem>
        </FlexBox>
      </StyledModal>
    </PromoBannerWrapper>
  );
};
